import { AfterViewInit, Component, ElementRef, Input, Output, ViewChild, EventEmitter, OnDestroy } from '@angular/core';
import { ControlContainer, FormControlName, FormGroupDirective } from '@angular/forms';
import { Timeouts } from 'app/shared/constants/timeout.constants';
import { Observable, Subscription } from 'rxjs';

/**
 * Input password component
 * @description Angular component. Show an input password with an right button
 * for show/hide current user data
 */

@Component({
  selector: 'ap-extended-input',
  templateUrl: './ap-extended-input.component.html',
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective,
    },
  ],
  styleUrls: ['ap-extended-input.scss'],
})
export class ExtendedInputComponent implements AfterViewInit, OnDestroy {
  @Input() controlName: string | number | null = '';
  @Input() initInputType = 'password';
  @Input() inputGroupText?: string;
  @Input() autocomplete = 'on';
  @Input() initFocus = false;

  @Input() crossFieldValidators?: string;

  @Input() events?: Observable<boolean>;
  eventsSubscription: Subscription | undefined;

  @Output() onFocusOut = new EventEmitter<void>();

  @ViewChild('inputChild') inputChild!: ElementRef;

  currentInputType = 'password';
  currentFormControl?: FormControlName;

  inputVisible = false;
  inputFocussed = false;
  inputInvalid = false;
  applyFocus = false;

  svgIconShow = 'content/images/icons/eye_visible.svg';
  svgInconHide = 'content/images/icons/eye_hide.svg';
  svgIcon = this.svgIconShow;

  constructor(private readonly el: ElementRef, public controller: FormGroupDirective) { }
  ngOnDestroy(): void {
    this.eventsSubscription?.unsubscribe();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.currentFormControl = this.controller.directives.filter(sElem => sElem.name === this.controlName).pop();
      this.currentInputType = this.initInputType;

      this.eventsSubscription = this.events?.subscribe(() => {
        setTimeout(() => {
          this.inputChild.nativeElement.focus();
        }, 0);
      });
    });
  }

  /**
   * Method that change the input type from text to password and viceversa
   * when user click on eye icon button
   */
  changeVisibility(): boolean {
    this.inputVisible = !this.inputVisible;
    if (!this.inputVisible) {
      this.currentInputType = 'password';
      this.svgIcon = this.svgIconShow;
    } else {
      this.currentInputType = 'text';
      this.svgIcon = this.svgInconHide;
    }
    return false;
  }

  inputFocusOut(): void {
    this.onFocusOut.emit();
    this.inputFocus(false);
  }

  /**
   * Utility method than set a specific class "focus" to parent container whenever
   * the input is focused by user interaction
   * @param focussed boolean
   */
  inputFocus(focussed: boolean): void {
    setTimeout(() => {
      this.inputFocussed = focussed;
    }, Timeouts.TIMEOUT_100);
  }

  onKeyDown(): void {
    this.inputInvalid = false;
  }
}
